<app-side-menu>
  
  <div class="position-form-container">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">
        {{ isEditMode ? 'Editar Cargo' : 'Novo Cargo' }}
      </h2>
      <button 
        class="btn btn-secondary"
        (click)="onCancel()">
        <i class="fas fa-times me-2"></i>
        Cancelar
      </button>
    </div>

    <div class="card">
      <div class="card-body">
        <form [formGroup]="positionForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-12 col-xl-6 mx-auto">
              
              <!-- Nome -->
              <div class="mb-3">
                <label for="name" class="form-label">
                  Nome <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  class="form-control"
                  [class.is-invalid]="isFieldInvalid('name')"
                  formControlName="name"
                  placeholder="Ex: Analista de RH">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('name')">
                  {{ getFieldError('name') }}
                </div>
              </div>

              <!-- Nível -->
              <div class="mb-3">
                <label for="level" class="form-label">
                  Nível
                </label>
                <select
                  id="level"
                  class="form-control"
                  formControlName="level">
                  <option [value]="">Selecione um nível...</option>
                  <option *ngFor="let option of levelOptions" [value]="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>

              <!-- Descrição -->
              <div class="mb-3">
                <label for="description" class="form-label">
                  Descrição
                </label>
                <textarea
                  id="description"
                  class="form-control"
                  [class.is-invalid]="isFieldInvalid('description')"
                  formControlName="description"
                  rows="3"
                  placeholder="Descrição do cargo..."></textarea>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
                  {{ getFieldError('description') }}
                </div>
              </div>

              <!-- Carga Horária -->
              <div class="mb-3">
                <label for="defaultWorkloadHours" class="form-label">
                  Carga Horária (horas/dia) <span class="text-danger">*</span>
                </label>
                <input
                  type="number"
                  id="defaultWorkloadHours"
                  class="form-control"
                  [class.is-invalid]="isFieldInvalid('defaultWorkloadHours')"
                  formControlName="defaultWorkloadHours"
                  min="1"
                  max="24"
                  placeholder="8">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('defaultWorkloadHours')">
                  {{ getFieldError('defaultWorkloadHours') }}
                </div>
                <small class="form-text text-muted">
                  Número de horas trabalhadas por dia (1 a 24 horas)
                </small>
              </div>

              <!-- Status Ativo -->
              <div class="mb-3">
                <div class="form-check">
                  <input
                    type="checkbox"
                    id="isActive"
                    class="form-check-input"
                    formControlName="isActive">
                  <label class="form-check-label" for="isActive">
                    Cargo ativo
                  </label>
                </div>
              </div>

              <!-- Botões -->
              <div class="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  class="btn btn-secondary"
                  (click)="onCancel()"
                  [disabled]="isSubmitting">
                  Cancelar
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  [disabled]="isSubmitting || positionForm.invalid">
                  <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
                  <i *ngIf="!isSubmitting" class="fas fa-save me-2"></i>
                  {{ isSubmitting ? 'Salvando...' : 'Salvar' }}
                </button>
              </div>

            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</app-side-menu>

